import logo from '../../../public/logo.svg'

const partnerLogoUrl = import.meta.env.VITE_FAVICON
export const PARTNER_LOGO = partnerLogoUrl || logo
